<template>
  <v-container>
    <v-row no-gutters class="mt-4">
      <v-col cols="12">
        <div class="app-name-container">
          <h1>自分で作成する英単語帳</h1>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-10">
      <v-col cols="12">
        <div class="title-container">
          <h1>効率的に英単語を暗記しよう！</h1>
          <p class="mt-4">
            App Storeで支持されている人気iOS英単語アプリが遂にWebに登場
          </p>
          <v-btn
            class="mt-4"
            color="primary"
            width="100%"
            height="60px"
            dark
            @click="goToSignUp"
          >
            無料で会員登録する
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-10">
      <v-col class="desc-container" lg="4" md="4" sm="4" cols="12">
        <h2 class="mb-2">暗記モード</h2>
        <v-card>
          <v-img src="../assets/desc1.png" aspect-ratio="1"></v-img>
        </v-card>
        <p class="mt-3">登録した後は演習・暗記テストまで</p>
      </v-col>
      <v-col class="desc-container" lg="4" md="4" sm="4" cols="12">
        <h2 class="mb-2">自由自在な単語帳</h2>
        <v-card>
          <v-img src="../assets/desc2.png" aspect-ratio="1"></v-img>
        </v-card>
        <p class="mt-3">どんな目的にも使えます</p>
      </v-col>
      <v-col class="desc-container" lg="4" md="4" sm="4" cols="12">
        <h2 class="mb-2">アプリ対応</h2>
        <v-card>
          <v-img src="../assets/desc3.png" aspect-ratio="1"></v-img>
        </v-card>
        <p class="mt-3">iOSアプリでいつでもどこでも</p>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-4">
      <v-col cols="12">
        <div class="title-container">
          <v-btn
            class="mt-4"
            color="primary"
            width="100%"
            height="60px"
            dark
            @click="goToSignUp"
          >
            無料で会員登録する
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "LandingPage",
  data: () => ({}),
  methods: {
    goToSignUp() {
      this.$router.push("/signup");
    },
  },
};
</script>

<style scoped>
.app-name-container {
  text-align: center;
}
.app-name-container h1 {
  font-size: 1.3em;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  background-image: url("../assets/english_logo_round.png");
  background-size: 40px 40px;
  background-repeat: no-repeat;
  padding: 0px 0px 0px 50px;
}
.title-container {
  text-align: center;
}
.title-container button {
  max-width: 300px;
}
.desc-container {
  text-align: center;
  padding: 10px;
}
</style>
